customElements.define(
    'vp-field',
    class extends HTMLElement {
        constructor() {
            super()
            this.defaultError = this.getAttribute('error') || 'error'
        }

        connectedCallback() {}

        setError(error) {
            switch (typeof error) {
                case 'string':
                    break
                case 'boolean':
                    if (error) {
                        error = this.defaultError
                    }
                    break
                default:
                    error = false
            }
            this.removeError()
            if (error) {
                const errorElement = document.createElement('div')
                errorElement.className = 'error'
                errorElement.innerHTML = error
                this.appendChild(errorElement)
            }
        }

        removeError() {
            const error = this.querySelector('.error')
            if (error) {
                error.remove()
            }
        }
    },
)
